import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Field, Form } from 'react-final-form';
import { NotificationManager } from 'react-notifications';
import Lightbox from 'react-image-lightbox';
import PanelContentWrapper from '../../components/PanelContentWrapper';
import { H1 } from '../../components/Headings';
import { apiUrl } from '../../api';
import { Button, ErrorMessage, Input, Select } from '../../components/FormComponents';
import { Permission } from '../../hooks/Permission';

const Tabs = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    width: 100%;
    grid-gap: 10px;
`;

const Tab = styled.button`
    display: flex;
    background: ${({ active, theme: { gray, orange } }) => (active ? orange : gray)};
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 10px 0;
    border: none;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
`;
const TabContent = styled.div``;

const StyledClient = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
`;
const StyledPanelContentWrapper = styled(PanelContentWrapper)`
    p {
        margin: 10px auto;
    }
`;

const StyledForm = styled.form`
    display: grid;
    flex-direction: row;
    align-items: center;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
`;

const StyledButton = styled(Button)`
    padding: 8px 20px;
`;

const ImageButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
`;

export const Contract = () => {
    const [tab, setTab] = useState(1);
    const [contract, setContract] = useState({});
    const match = useRouteMatch();
    const token = useSelector((store) => store.token);
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [photoIndex, setPhotoIndex] = useState(0);

    useEffect(() => {
        axios
            .get(`${apiUrl}/contract/${match.params.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(({ data: { contract: newContract } }) => {
                setContract(newContract);

                setImages([newContract.idPhotoUrl, newContract.idPhotoBackUrl, newContract.facePhotoUrl]);
            });
    }, [token, match.params.id]);

    return (
        <>
            <Permission permission="contract-update" />
            <StyledPanelContentWrapper>
                <H1>
                    {contract.name} {contract.surname} / {contract.offerType} /{' '}
                    {contract.isNewNumber ? 'Nowy numer' : 'Przeniesienie numeru'}
                </H1>
                <p>Ofera: {contract.offerType}</p>
                <p>Nowy numer: {contract.isNewNumber}</p>
                <p>Partner biznesowy: {contract.isCompany}</p>
                <p>Taryfa: {contract.tariff}</p>
                <p>Pakiet: {contract.package}</p>
                <p>Abonament: {contract.packageDescription}</p>
                <p>Kod promocyjny: {contract.promoCode}</p>
                <p>Wybór produktu: {contract.promoItem}</p>
                <p>Wybrany numer: {contract.newNumber}</p>
                <p>Zgody: Regulamin / Polityka prywatności / Zgoda marketingowa</p>

                <p>KLIENT</p>
                <StyledClient>
                    <div>
                        <p>Imię: {contract.name}</p>
                        <p>Nazwisko: {contract.surname}</p>
                        <p>E-mail: {contract.email}</p>
                        <p>Telefon: {contract.phone}</p>
                        <p>Nazwa firmy: {contract.companyName}</p>
                        <p>NIP: {contract.nip}</p>
                        <p>REGON: {contract.regon}</p>
                    </div>
                    <div>
                        <p>PESEL: {contract.pesel}</p>
                        <p>Numer dowodu: {contract.idNumber}</p>
                        <p>Data ważności dowodu: {contract.idDate}</p>
                        <p>Ulica i numer lokalu: {contract.street}</p>
                        <p>Miejscowość: {contract.city}</p>
                        <p>Kod pocztowy: {contract.postCode}</p>
                    </div>
                    <div>
                        <ImageButton onClick={() => setIsOpen(true)}>
                            <img src={contract.idPhotoUrl} alt="" width="250" />
                        </ImageButton>
                        <ImageButton onClick={() => setIsOpen(true)}>
                            <img src={contract.idPhotoBackUrl} alt="" width="250" />
                        </ImageButton>
                    </div>
                    <div>
                        <ImageButton onClick={() => setIsOpen(true)}>
                            <img src={contract.facePhotoUrl} alt="" width="250" />
                        </ImageButton>
                    </div>
                </StyledClient>

                <Tabs>
                    <Tab
                        active={tab === 1}
                        onClick={() => {
                            setTab(1);
                        }}
                    >
                        Treść umowy
                    </Tab>
                    <Tab
                        active={tab === 2}
                        onClick={() => {
                            setTab(2);
                        }}
                    >
                        E-mail 1
                    </Tab>
                    <Tab
                        active={tab === 3}
                        onClick={() => {
                            setTab(3);
                        }}
                    >
                        E-mail 2
                    </Tab>
                    <Tab
                        active={tab === 4}
                        onClick={() => {
                            setTab(4);
                        }}
                    >
                        E-mail 3
                    </Tab>
                    <Tab
                        active={tab === 5}
                        onClick={() => {
                            setTab(5);
                        }}
                    >
                        PDF
                    </Tab>
                </Tabs>
                <TabContent>
                    {tab === 1 && <>{contract.contractContent}</>}
                    {tab === 2 && <>{contract.emailContent}</>}
                    {tab === 3 && <>{contract.emailContent2}</>}
                    {tab === 4 && <>{contract.emailContent3}</>}
                    {tab === 5 && <>5</>}
                </TabContent>

                <StyledClient>
                    <div>
                        <p>Data: {contract.date}</p>
                        <p>Godzina: {contract.time}</p>
                        <p>Urządzenie: {contract.device}</p>
                    </div>
                    <div>
                        <p>Model urządzenia: {contract.deviceModel}</p>
                        <p>Formularz wysłano z IP: {contract.ip}</p>
                        <p>Kod SMS: {contract.smsCode}</p>
                    </div>
                </StyledClient>

                <Form
                    onSubmit={(values, form) => {
                        axios
                            .put(`${apiUrl}/contract/${match.params.id}`, values, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            })
                            .then(({ data: { contract: newContract } }) => {
                                form.reset(newContract);
                                NotificationManager.success('Zapisano zmiany');
                            })
                            .catch(() => {
                                NotificationManager.error('spróbuj ponownie', 'Błąd ');
                            });
                    }}
                    initialValues={contract}
                    render={({ handleSubmit, values }) => (
                        <StyledForm onSubmit={handleSubmit}>
                            <Field
                                name="status"
                                render={({ input, meta }) => (
                                    <>
                                        <Select {...input}>
                                            <option value="">Status</option>
                                            <option value="NOWA">NOWA</option>
                                            <option value="Rozpatrzona pozytywnie">Rozpatrzona pozytywnie</option>
                                            <option value="Rozpatrzona negatywnie">Rozpatrzona negatywnie</option>
                                            <option value="Wprowadzona">Wprowadzona</option>
                                        </Select>
                                        {meta.error && meta.touched && <ErrorMessage>{meta.error}</ErrorMessage>}
                                    </>
                                )}
                            />
                            {values.status === 'Wprowadzona' && (
                                <>
                                    <Field
                                        name="contractNumber"
                                        render={({ input, meta }) => (
                                            <>
                                                <Input {...input} placeholder="Numer umowy" />
                                                {meta.error && meta.touched && (
                                                    <ErrorMessage>{meta.error}</ErrorMessage>
                                                )}
                                            </>
                                        )}
                                    />
                                </>
                            )}
                            <StyledButton>Zapisz</StyledButton>
                        </StyledForm>
                    )}
                />
            </StyledPanelContentWrapper>
            {isOpen && (
                <>
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setIsOpen(false)}
                        onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                        onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                    />
                </>
            )}
        </>
    );
};
